import { FC, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '../../../store/store';

import Spinner from '../../atoms/Spinner/Spinner';
import { LandscapeCommoditiesEditTemplate } from '../../templates';
import { useNavigate, useParams } from 'react-router-dom';
import { LandscapeCommodityResponseDto } from '../../../store/landscapeAPI/landscape/dto/response/landscape-commodity-response.dto';
import {
  fetchCommoditiesByLandscapeId,
  fetchCommodityLandscapeById,
  updateCommodityLandscape,
} from '../../../store/tradeAPI/commodity/reducers/commodity-landscape.slice';
import { LandscapeCommodityUpdateRequestDto } from '../../../store/landscapeAPI/landscape/dto/request/landscape-commodity-update-request.dto';

interface LandscapeCommoditiesEditPageProps {}

const LandscapeCommoditiesEditPage: FC<
  LandscapeCommoditiesEditPageProps
> = () => {
  const { commodityId } = useParams();
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const { status } = useSelector(
    (state: RootState) => state.commodityLandscapeSlice
  );
  const [commodityLandscape, setCommodityLandscape] =
    useState<LandscapeCommodityResponseDto>();

  const handleOnChange = (
    commodityLandscape: LandscapeCommodityResponseDto
  ) => {
    setCommodityLandscape(commodityLandscape);
  };

  const callbackFn = async (
    commodityLandscape: LandscapeCommodityResponseDto
  ) => {
    const commodityLandscapeToUpdate: LandscapeCommodityUpdateRequestDto = {
      availabilityType: commodityLandscape.availabilityType,
      qty: commodityLandscape.qty,
      time: commodityLandscape.time,
      compactId: commodityLandscape.compactId,
      commodityId: commodityLandscape.commodityId,
      id: commodityLandscape.id,
      published: commodityLandscape.published,
    };
    await dispatch(updateCommodityLandscape(commodityLandscapeToUpdate));
    if (id) {
      dispatch(fetchCommoditiesByLandscapeId(id));
    }
    navigate(`/landscapes/edit/${id}/commodities`);
  };

  useEffect(() => {
    if (commodityId) {
      dispatch(fetchCommodityLandscapeById(commodityId))
        .unwrap()
        .then((commodity: LandscapeCommodityResponseDto) =>
          setCommodityLandscape(commodity)
        );
    }
  }, [dispatch, commodityId]);

  if (status === 'loading') {
    return <Spinner />;
  }

  return (
    <>
      {commodityLandscape && (
        <LandscapeCommoditiesEditTemplate
          commodityLandscape={commodityLandscape}
          handleOnChange={handleOnChange}
          callbackFn={callbackFn}
        />
      )}
    </>
  );
};

export default LandscapeCommoditiesEditPage;
